import apiInstance from "../api";
import endPoints from "../endpoints";

export const getMappings = (payload) => {
  return apiInstance().post(`${endPoints.ai.getMappings}`, payload);
};

export const getTextToSql = (payload) => {
  return apiInstance().post(`${endPoints.ai.getTextToSql}`, payload);
};
